import { Menu } from 'antd';
import SiderBrand from './SiderBrand';
import SiderUser from './SiderUser';
import type { Me } from '../api/client';

export type NavItem = {
  key: string;
  icon: React.ReactNode;
  label: string;
};

interface Props {
  me: Me;
  collapsed: boolean;
  items: NavItem[];
  selected: string;
  onNavigate: (key: string) => void;
}

/** 側欄內容（品牌 + 深色選單 + 左下使用者）：桌機 Sider 與手機 Drawer 共用。 */
export default function SiderNav({ me, collapsed, items, selected, onNavigate }: Props) {
  return (
    <div className="flex h-full flex-col">
      <SiderBrand collapsed={collapsed} />
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[selected]}
        items={items}
        onClick={({ key }) => onNavigate(key)}
        style={{ background: 'transparent', borderInlineEnd: 'none' }}
      />
      <SiderUser me={me} collapsed={collapsed} />
    </div>
  );
}
